
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Ω / Icons / platforms / router","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 29.218 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Combined Shape","d":"M23.131 28H6.087a6.087 6.087 0 010-12.173h10.348v-3.652a1.217 1.217 0 112.434 0v3.652h4.261a6.087 6.087 0 110 12.173zM20.7 20.087a1.826 1.826 0 101.826 1.826 1.828 1.828 0 00-1.826-1.826zm-6.087 0a1.826 1.826 0 101.826 1.826 1.828 1.828 0 00-1.83-1.826zM20.754 9.109a3.94 3.94 0 00-2.92-1.5H17.532a3.944 3.944 0 00-2.876 1.373l-.106.128a1.217 1.217 0 01-1.907-1.51 6.385 6.385 0 014.631-2.41l.2-.009h.173A6.382 6.382 0 0122.662 7.6a1.218 1.218 0 01-1.908 1.513zm3.716-3.617a9.1 9.1 0 00-6.568-3.054h-.423a9.106 9.106 0 00-6.645 3.054 1.217 1.217 0 01-1.817-1.62A11.543 11.543 0 0117.18.01l.264-.01h.208a11.536 11.536 0 018.635 3.872 1.217 1.217 0 11-1.817 1.62z","fill":"#011936"}})])
          )
        }
      }
    